import { CardInfoPartialStoreState, CARD_INFO_STATE_KEY } from './card-info.reducer';

export const getCardNumber = (state: CardInfoPartialStoreState) => state[CARD_INFO_STATE_KEY].card_number;
export const getBalance = (state: CardInfoPartialStoreState) => state[CARD_INFO_STATE_KEY].balance;
export const getHistory = (state: CardInfoPartialStoreState) => state[CARD_INFO_STATE_KEY].history;
export const getTickets = (state: CardInfoPartialStoreState) => state[CARD_INFO_STATE_KEY].tickets;